<ion-content [fullscreen]="true">
  <div class="container">

    <div style="width: 100%; margin-bottom: 30px;">
      <img style="width: 250px;" src="assets/icon/common/altomate_logo.png" alt="">
    </div>

    <h1>Mandatory Update Required</h1>
    <div class="version">New Version: {{ latestVersion }}</div>

    <p class="message">Your app requires an update to continue. Please download the latest version to access the app.
    </p>

    <div class="warning">
      You cannot use the app until you update to the latest version.
    </div>

    <div class="download-buttons">
      <button (click)="openMarket()" class="download-btn apple">
        Download for {{ platform.is('ios') ? 'iOS' : 'Android' }}
      </button>
    </div>

    <div class="current-version">
      Your current version: {{currentVersion}}
    </div>
  </div>
</ion-content>